var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path-bg",
    d: "M0 0H30C32.2091 0 34 1.79086 34 4V30C34 32.2091 32.2091 34 30 34H0V0Z",
    fill: "#F9F8F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "path-stroke",
    d: "M25.25 25.25H10.2167C9.70329 25.25 9.44659 25.25 9.25051 25.1501C9.07803 25.0622 8.93779 24.922 8.84991 24.7495C8.75 24.5534 8.75 24.2967 8.75 23.7833V8.75M25.25 12.4167L20.2685 17.3981C20.087 17.5796 19.9963 17.6704 19.8916 17.7044C19.7996 17.7343 19.7004 17.7343 19.6084 17.7044C19.5037 17.6704 19.413 17.5796 19.2315 17.3981L17.5185 15.6852C17.337 15.5037 17.2463 15.4129 17.1416 15.3789C17.0496 15.349 16.9504 15.349 16.8584 15.3789C16.7537 15.4129 16.663 15.5037 16.4815 15.6852L12.4167 19.75M25.25 12.4167H21.5833M25.25 12.4167V16.0833",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphView);
export default __webpack_public_path__ + "static/media/Graph-view.c36eb221ce2c701ed9738c8b859acb48.svg";
export { ForwardRef as ReactComponent };